import {h, Fragment} from "preact"
export default function RangeInput({ className, ...props }) {
    return <input type="number" step="0.01" className={`ns-input-field ns-d-block ${className}`} {...props} />
}